import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from "react";
import { Animated, StyleSheet, useWindowDimensions } from "react-native";
import { Circle, Svg } from "react-native-svg";
import { Text } from "./Text";
import { View } from "./View";
import { useTheme } from "../styles";
var OFFWHITE = 'rgba(255,255,255,0.6)';
var AnimatedCircle = Animated.createAnimatedComponent(Circle);
/**
 * Renders a circle indicating percentage completion. Size can be configured
 *
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-45}
 */ export function AnimatedProgressCircle(param) {
    var color = param.color, _param_backgroundColor = param.backgroundColor, backgroundColor = _param_backgroundColor === void 0 ? '#c5c5d3' : _param_backgroundColor, testID = param.testID, ariaLabel = param['aria-label'], text = param.text, progress = param.progress, _param_strokeWidth = param.strokeWidth, strokeWidth = _param_strokeWidth === void 0 ? 3 : _param_strokeWidth, _param_size = param.size, size = _param_size === void 0 ? 34 : _param_size;
    var fontScale = useWindowDimensions().fontScale;
    var complete = progress === 1;
    var strokeDashoffsetRef = useRef(new Animated.Value(progress !== null && progress !== void 0 ? progress : 1));
    var theme = useTheme().theme;
    color || (color = theme.color.accent100);
    var svgProgress = 100 - (progress !== null && progress !== void 0 ? progress : 1) * 100;
    var percent = Math.floor(progress * 100);
    var radius = (size - strokeWidth) / 2;
    var circum = radius * 2 * Math.PI;
    useEffect(function() {
        var strokeDashoffset = radius * Math.PI * 2 * (svgProgress / 100);
        Animated.timing(strokeDashoffsetRef.current, {
            toValue: strokeDashoffset,
            duration: 200,
            useNativeDriver: true
        }).start();
    }, [
        svgProgress,
        radius
    ]);
    return /*#__PURE__*/ _jsx(View, {
        testID: testID,
        "aria-label": ariaLabel ? "".concat(ariaLabel, ". ").concat(percent, " percent") : undefined,
        accessible: !!ariaLabel,
        children: /*#__PURE__*/ _jsx(View, {
            testID: "AnimatedProgressCircle_progress_".concat(percent),
            children: /*#__PURE__*/ _jsxs(View, {
                style: {
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: size * fontScale,
                    height: size * fontScale,
                    borderRadius: 18
                },
                children: [
                    /*#__PURE__*/ _jsx(View, {
                        style: StyleSheet.absoluteFillObject,
                        children: /*#__PURE__*/ _jsx(Svg, {
                            viewBox: "0 0 ".concat(size, " ").concat(size),
                            children: /*#__PURE__*/ _jsx(AnimatedCircle, {
                                stroke: backgroundColor,
                                fill: "none",
                                cx: size / 2,
                                cy: size / 2,
                                r: radius,
                                strokeDasharray: "".concat(circum, " ").concat(circum),
                                strokeDashoffset: 0,
                                strokeLinecap: "round",
                                strokeWidth: "2"
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(View, {
                        style: StyleSheet.absoluteFillObject,
                        children: /*#__PURE__*/ _jsx(Svg, {
                            viewBox: "0 0 ".concat(size, " ").concat(size),
                            children: /*#__PURE__*/ _jsx(AnimatedCircle, {
                                stroke: complete || progress ? color : OFFWHITE,
                                fill: complete ? color : 'none',
                                cx: size / 2,
                                cy: size / 2,
                                r: radius,
                                strokeDasharray: "".concat(circum, " ").concat(circum),
                                strokeDashoffset: strokeDashoffsetRef.current,
                                strokeLinecap: "round",
                                transform: "rotate(-90, ".concat(size / 2, ", ").concat(size / 2, ")"),
                                strokeWidth: strokeWidth
                            })
                        })
                    }),
                    text ? /*#__PURE__*/ _jsx(Text, {
                        text: text,
                        color: complete ? 'white' : theme.color.gray300,
                        weight: complete ? 'bold' : undefined,
                        style: {
                            lineHeight: size
                        }
                    }) : null
                ]
            })
        })
    });
}
